export enum UmpireOttEventStatus {
  started = 'started',
  finished = 'finished',
  scheduled = 'scheduled',
}
